import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    header: 'mb-6',
    title: 'heading-2xl lg:heading-2xl-desk mb-1',
    subtitle: 'mb-4 text-sm text-gray-500',
    suggestions: 'flex flex-col gap-1 bg-white p-0',
    suggestion:
      'font-["RF Tone",sans-serif] cursor-pointer px-4 py-2 text-[18px] leading-[1.5] font-light transition-colors hover:bg-gray-100',
    inputClear:
      'flex size-6 cursor-pointer place-items-center items-center justify-center rounded-full bg-gray-100',
    inputClearIcon: 'text-icon-secondary',
    loading: 'loading h-6 w-6',
    loadingContainer:
      'absolute top-0 left-0 flex h-full w-full items-center justify-center bg-white/50'
  },
  variants: {
    color: {
      primary: 'text-black'
    }
  },
  defaultVariants: {
    color: 'primary'
  }
});
